<template>
    <div class="medical-records">
        <div class="row m-0 diet-section">
            <div class="col-12 mb-3 d-flex justify-content-between align-items-center mainFlex flex-wrap">
                <div class="mobScroll">
                    <ul class="nav nav-tabs noWrap mb-0" role="tablist">
                        <li class="nav-item pl-0"><a class="nav-link" data-toggle="tab"  role="tab" @click.prevent="tab = 'custom'" :class="(tab =='custom')?'active':''">Custom Suppliment</a></li>
                        <li class="nav-item"><a class="nav-link" data-toggle="tab" role="tab" @click.prevent="tab = 'generic'" :class="(tab =='generic')?'active':''">Generic Supplements</a></li>
                        <li class="nav-item"><a class="nav-link" data-toggle="tab" role="tab" @click.prevent="tab = 'recommended'" :class="(tab =='recommended')?'active':''">Recommended By Doctor</a></li>
                    </ul>
                </div>
                <router-link to="/already-taking-suppliment" class="Already"><img src="../../../../static/website/images/medicine.svg" alt="" class="icon-medicine mr-2" />Already Taking Suppliment</router-link>
            </div>
        </div>
        <div class="row mb-4 Nutrition">
            <div class="col-12">
                <div class="card border-0">
                    <div class="card-body bg-white border-radius-5">
                        <!-- Tab panes -->
                        <div class="tab-content">
                            <custom-suppliment v-if="tab == 'custom'"></custom-suppliment>
                            <generic-suppliment v-if="tab == 'generic'"></generic-suppliment>
                            <recommended-doctor v-if="tab == 'recommended'"></recommended-doctor>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import customsuppliment from './pages/custom-suppliment'
    import genericsuppliment from './pages/generic-suppliment'
    import recommendeddoctor from './pages/recommended-doctor'
    export default {
        name: "Nutrition",
        data() {
            return {
                tab :'custom',

            }
        },
        components:{
            customSuppliment: customsuppliment,
            genericSuppliment : genericsuppliment,
            recommendedDoctor: recommendeddoctor
        },
        created(){
           this.pageName('Nutrition and Supplements');
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/website/nutrition/nutrition_suppliment.vue